module.exports = __webpack_public_path__ + "img/pic_xishouye1.ff381f90.png";